import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  FormControl,
  Text,
  Textarea,
  useDisclosure,
  useToast,
} from "@chakra-ui/react"
import React from "react"
import { api } from "../../../../services/api"
import { useMutation, useQueryClient } from "react-query"
import { FormLabel } from "react-bootstrap"

export function RecusarRetificacao({ item }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()
  const observacao = React.useRef()

  const queryClient = useQueryClient()

  const toast = useToast({
    position: "top",
  })

  async function updateRetificacao(params) {
    const response = await api.post(`/site/v2/fluxo-layout/recusa-retificacao-layout`, {
      ...params,
    })
    console.log(response.data)

    return response.data
  }

  const { mutateAsync: recuseRetification } = useMutation({
    mutationFn: updateRetificacao,
    mutationKey: "updateRetificacao",
    onError: (error) => {
      console.log(error)
      toast({
        title: "Erro ao recusar retificação",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: (data) => {
      console.log(data)
      queryClient.invalidateQueries("getInfoRetificacaoLayout")
      onClose()
      toast({
        title: "Retificação recusada com sucesso",
        status: "success",
        duration: 9000,
        isClosable: true,
      })
    },
  })
  console.log(item)

  async function handleUpdateRetificacao(approve) {
    if (!observacao.current) {
      return toast({
        title: "Observação é obrigatória",
        status: "error",
        duration: 9000,
        isClosable: true,
      })
    }

    const paramsToApprove = {
      gravacao: item.gravacao,
      cor: item.cor,
      prazo: item.prazo_entrega,
      batidas: item.batidas,
      numero_nota: item.numero_nota,
      sequencia: item.sequencia,
      numero_unico: item.numero_nota,
      codprod: item.codprod,
      link_layout: item.link_layout,
      observacao: observacao.current,
      nome_vendedor: item.nome_vendedor,
      referencia: item.referencia,
      numero_pedido: item.numero_pedido,
    }

    try {
      await recuseRetification(paramsToApprove)
    } catch (error) {}
  }

  return (
    <>
      <Button colorScheme="red" size="sm" onClick={onOpen}>
        Recusar
      </Button>

      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Recusar Retificação
            </AlertDialogHeader>

            <AlertDialogBody display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"}>
              <Text>Tem certeza que deseja recusar a retificação?</Text>

              <FormControl mt={4} w={"100%"}>
                <FormLabel>Observação</FormLabel>
                <Textarea
                  placeholder="Observação"
                  required
                  resize={"none"}
                  onChange={(e) => {
                    observacao.current = e.target.value
                  }}
                />
              </FormControl>
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={handleUpdateRetificacao} ml={3}>
                Recusar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
